export enum ArtworkAddViewStage {
  BasicInfo = 'basicInfo',
  Details = 'details',
  Success = 'success',
  Error = 'error',
}
